import { EBoneType } from "$src/CGS/domain/dto/core/bones/EBoneType";
import { Object3D } from "three";

export class BoneObject extends Object3D {

    public Type: EBoneType = EBoneType.Hob;

    constructor() {
        super();
    }
}
